import { Autocomplete, Button, CircularProgress, Dialog, DialogContent, Grid, IconButton, InputAdornment, TextField, Typography } from '@mui/material';
import React, { useCallback, useEffect, useState } from 'react'
import CloseIcon from "@mui/icons-material/Close";
import icon_edit from "../../../../../Image/icon_edit.png";
import PersonSearchIcon from "@mui/icons-material/PersonSearch";
import { APIEndpointWeb, GetLocalStorageAccessToken, webapi } from '../../../../../client/web';
import LoadingIndicator from '../Loading/LoadingIndicator';
import DialogConfirmApprover from './DialogConfirmApprover';
import Swal from 'sweetalert2';
interface IDataDialogNoInformationFound {
    setOpenErrorDialog: (open: boolean) => void;
    openErrorDialog: boolean;
}

interface Film {
    title: string;
    year: number;
}


interface IOptionDetail {
    document_no: string;
    priority: string;
    cidData: string;
    prefix: string;
    name: string;
    position: string;
}

interface IOpenChangeApprover {
    setOpenChangeApprover: any;
    openChangeApprover: boolean;
    handlePostDetailPerson: any;
    optionsDetail: IOptionDetail[];
    resTablePending: any;
}

const sleep = (ms: number): Promise<void> =>
    new Promise((resolve) => setTimeout(resolve, ms));

const top100Films = [
    { title: "The Shawshank Redemption", year: 1994 },
    { title: "The Godfather", year: 1972 },
    { title: "The Godfather: Part II", year: 1974 },
    { title: "The Dark Knight", year: 2008 },
    { title: "12 Angry Men", year: 1957 },
    { title: "Schindler's List", year: 1993 },
    { title: "Pulp Fiction", year: 1994 },
];


const DialogChangeApprover: React.FC<IOpenChangeApprover> = ({ setOpenChangeApprover, openChangeApprover, handlePostDetailPerson, optionsDetail, resTablePending }) => {
    const [loadingAutocomplete, setLoadingAutocomplete] = useState(false);
    const [openAutocomplete, setOpenAutocomplete] = useState(false);
    const [options, setOptions] = useState<Film[]>([]);
    const [inputValueAutocomplete, setInputValueAutocomplete] = useState("");
    const [position, setPosition] = useState("");
    const [approverAutocomplete, setApproverAutocomplete] = useState<any | null>(null);
    const [dataPPho, setPPho] = useState<any | null>(null);
    const [dataPrefix, setDataPrefix] = useState("");
    const [accessToken, setAccessToken] = useState<string>(
        GetLocalStorageAccessToken()
    );
    const [loadingBTN, setLoadingBTN] = useState<boolean>(false);
    const [openDialogSuscess, setOpenDialogSuscess] = useState<boolean>(false);

    // useEffect(() => {
    //     if (!openAutocomplete) {
    //         setOptions([]);F
    //         return;
    //     }

    //     setLoadingAutocomplete(true);
    //     sleep(1000).then(() => {
    //         setLoadingAutocomplete(false);
    //         setOptions(top100Films);
    //     });
    // }, [openAutocomplete]);

    useEffect(() => {
        if (!openAutocomplete) {
            setOptions([]);
            return;
        }

        setLoadingAutocomplete(true);
        setTimeout(() => {
            setLoadingAutocomplete(false);
            // setOptions(top100Films); // Uncomment if you have sample data.
        }, 1000);
    }, [openAutocomplete]);

    useEffect(() => {
        if (Array.isArray(optionsDetail) && optionsDetail.length > 0) {
            setApproverAutocomplete(optionsDetail[0]);
            setPosition(optionsDetail[0].position);
            getPostListPphoMember()
        } else {
            setApproverAutocomplete(null);
            setPosition("");
        }


    }, [optionsDetail]);


    const getPostListPphoMember = async () => {
        try {
            let datax = {
                document_no: optionsDetail?.[0]?.document_no,
            };

            var { data } = await webapi.post(`${APIEndpointWeb.PostListPphoMember}`, datax,
                {
                    headers: { Authorization: `Bearer ${accessToken}` },
                }
            );
            // console.log(APIEndpointWeb.PostListPphoMember, data)
            setPPho(data.result && data.result.length > 0 ? data.result : [])
            console.log('data.result :>> ', data.result);
        } catch (error) {
            console.log(error)
            // setBase64OfSign('')
        } finally {
            //   setLoading(false);
        }
    };


    const handleSaveChange = async () => {
        try {
            // setOpenOrderDocDialog(false);
            setLoadingBTN(true);
            const dataApi = {
                document_no: resTablePending.document_no,
                priority: resTablePending.priority,
                cid: approverAutocomplete.cid,
                prefix: approverAutocomplete.prefix,
                name: approverAutocomplete.name,
            };
            var { data } = await webapi.post(
                APIEndpointWeb.PostChangePerson,
                dataApi,
                {
                    headers: { Authorization: `Bearer ${accessToken}` },
                }
            );
            setLoadingBTN(false);
        } catch (error) {
            Swal.fire({
                title: "เปลี่ยนแปลงผู้มีสิทธิ์อนุมัติเอกสารไม่สำเร็จ",
                icon: "error",
            });
            setLoadingBTN(false);
        
            console.log(error);
        }
    };



    const handleCloseErrorDialog = () => {
        setOpenChangeApprover(false);
        // setOpenErrorDialog(false);
    };

    const handleOpenDialog = () => {
        setOpenDialogSuscess(true);
        // setOpenErrorDialog(false);
    };
    // console.log('optionsDetail :>> ', optionsDetail);

    return (
        <div>

            <Dialog
                open={openChangeApprover}
                onClose={(event, reason) => {
                    if (reason !== "backdropClick" && reason !== "escapeKeyDown") {
                        handleCloseErrorDialog();
                    }
                }}
                fullWidth
                maxWidth={false}
                PaperProps={{
                    sx: {
                        bgcolor: "#FFFFFF",
                        borderRadius: "20px",
                        boxShadow: 3,
                        p: 1,
                        width: "540px",
                    },
                }}
            >
                <DialogContent>
                    <Grid
                        container
                        spacing={2}
                    >
                        <Grid sx={{ display: "flex", alignItems: "center" }}>
                            <Grid item >
                                <img
                                    src={icon_edit}
                                    alt="รูปภาพ"
                                    style={{
                                        width: '25px',
                                        height: "auto",
                                        marginRight: 8,
                                    }}
                                />
                            </Grid>
                            <Grid item >
                                <Typography sx={{ color: "#2F4165", fontSize: '16px', fontWeight: 700 }}>
                                    เปลี่ยนแปลงผู้มีสิทธิ์อนุมัติเอกสารในนามกระทรวงสาธารณสุข
                                </Typography>
                            </Grid>
                            <Grid item xs sx={{ position: 'absolute', right: 8 }}>
                                <IconButton
                                    aria-label="delete"
                                    onClick={() => setOpenChangeApprover(false)}
                                >
                                    <CloseIcon />
                                </IconButton>
                            </Grid>
                        </Grid>
                        <Grid item xs={12} mt={2}>
                            <Typography
                                sx={{
                                    color: "#636363",
                                    fontSize: "15px",
                                }}
                            >
                                เลือกผู้มีสิทธิ์อนุมัติ
                            </Typography>

                            <Autocomplete
                                sx={{
                                    mt: 2,
                                    width: "100%",
                                    "& .MuiInputBase-root": {
                                        height: "40px",
                                    },
                                    "& .MuiOutlinedInput-root": {
                                        borderRadius: "30px",
                                        backgroundColor: "#fff",
                                    },
                                }}
                                clearIcon={false}
                                open={openAutocomplete}
                                onOpen={() => setOpenAutocomplete(true)}
                                onClose={() => setOpenAutocomplete(false)}
                                options={Array.isArray(dataPPho) ? dataPPho : []}
                                // getOptionLabel={(option) =>
                                //     typeof option === "string"
                                //       ? option // when Autocomplete is using string (during typing)
                                //       : `${option?.prefix ?? ''} ${option?.name ?? ''}`
                                //   }
                                getOptionLabel={(option) => option?.prefix + option?.name}
                                loadingText="กำลังค้นหา..."
                                loading={loadingAutocomplete}
                                inputValue={inputValueAutocomplete}
                                onInputChange={(_, newInputValue) =>
                                    setInputValueAutocomplete(
                                        newInputValue
                                    )
                                }
                                placeholder="เลือกผู้มีสิทธิ์อนุมัติ"
                                value={approverAutocomplete}
                                onChange={(_, newValue) => {
                                    setApproverAutocomplete(newValue);
                                    // setPPho(newValue);
                                    setPosition(newValue ? newValue.position : "ไม่พบข้อมูล");
                                    setDataPrefix(newValue ? newValue.prefix : "");
                                }}

                                // noOptionsText={
                                //     // "ไม่พบข้อมูล"
                                //     approverAutocomplete&& approverAutocomplete ? `"${approverAutocomplete}" ไม่พบข้อมูล` : "ไม่มีข้อมูล"
                                // }
                                noOptionsText={
                                    inputValueAutocomplete
                                        ? `"${inputValueAutocomplete}" ไม่พบข้อมูล`
                                        : "ไม่มีข้อมูล"
                                }
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        placeholder="เลือกผู้มีสิทธิ์อนุมัติ"
                                        InputProps={{
                                            ...params.InputProps,
                                            sx: {
                                                "& .MuiOutlinedInput-notchedOutline":
                                                {
                                                    borderColor: "green", // Default border color
                                                },
                                                "&:hover .MuiOutlinedInput-notchedOutline":
                                                {
                                                    borderColor: "darkred", // Hover border color
                                                },
                                                "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                                {
                                                    borderColor:
                                                        "#0288D1 !important", // Focus border color
                                                },
                                            },
                                            endAdornment: (
                                                <>
                                                    {loadingAutocomplete ? (
                                                        <CircularProgress
                                                            color="inherit"
                                                            size={20}
                                                        />
                                                    ) : null}
                                                    {params.InputProps.endAdornment}
                                                </>
                                            ),
                                        }}
                                    />
                                )}
                            />

                            <Typography color={'#434343'} mt={2}>ตำแหน่ง : {position ? position : <span style={{ color: '#bdbdbd' }}>ไม่พบข้อมูลตำแหน่ง</span>}</Typography>
                        </Grid>
                    </Grid>
                    <Grid container justifyContent={'center'} display={'flex'} mt={10}>
                        <Button
                            onClick={handleOpenDialog}
                            variant='contained'
                            sx={{ backgroundColor: '#0288D1', borderRadius: 2 }}>บันทึการเปลี่ยนแปลง</Button>
                    </Grid>

                </DialogContent>
            </Dialog>

            <DialogConfirmApprover
                setOpenDialogSuscess={setOpenDialogSuscess}
                openDialogSuscess={openDialogSuscess}
                handleSaveChange={handleSaveChange}
                setOpenChangeApprover={setOpenChangeApprover}
                loadingBTN={loadingBTN} />
        </div >
    )
}

export default DialogChangeApprover;
